import React from 'react';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../base/i18n.js";
import SearchInput from "../../inputs/search_input.js"
import URLParams from "../../../utils/url_params.js";

const styles = theme => ({
  spacer: {
    flexGrow: 1
  },
  row: {
    minHeight: '42px',
    display: 'flex',
    alignItems: 'center',
  },
});

class ListPageHeader extends React.Component {

  constructor(props) {
    super(props);

    let params = URLParams.getValues();

    this.state = {
      query: params.query || ""
    }

    this.onChangeQuery = this.onChangeQuery.bind(this);
  }

  onChangeQuery(query) {
    const { onChangeFilter } = this.props;
    this.setState({
      query: query
    })
    if(onChangeFilter) {
      onChangeFilter("query", query);
    }
  }

  render() {
    const { classes, children } = this.props;
    const { query } = this.state;

    return <div className = { classes.root } >
      <div className = { classes.row }>
        <SearchInput className = { classes.searchInput } 
                     placeholder = { I18n.t("admin.shared.query") } 
                     onChange = { this.onChangeQuery }
                     value = { query }
                     withDelay = { true } />
        <div className = { classes.spacer } />
        <div className = { classes.buttons } >
          { children }
        </div>
      </div>
    </div>
  }
}

export default withStyles(styles)(ListPageHeader);